<template>
    <Modal @close="onClose">
        <template #content>
            <ModalStandard :uiTitle="titleLbl" :uiIsGlobal="false" @close="onClose" class="br-m">
                <template #body>
                    <AthFormCheckbox :lbl="checkboxLbl" v-model="confirmed" />
                </template>
                <template #footer>
                    <AthButton class="el--s-m el--t-primary"
                        type="submit"
                        :lbl="confirmLbl"
                        :disabled="!confirmed"
                        @click.prevent.stop="onSubmit" />
                </template>
            </ModalStandard>
        </template>
    </Modal>
</template>
<script>
import ModalStandard from '../modal-styles/Standard.vue';
import AthButton from '../../atoms/Button.vue';
import AthFormCheckbox from '../../atoms/forms/FormCheckbox.vue';
import Modal from './Modal.vue';

export default {
    name: 'mead-standalone-checkbox-confirm-modal',
    props: {
        /**
         * Title text (i18n key) displayed in the modal's header.
         */
        titleLbl: {type: String, default: ''},
        /**
         * Label text (i18n key) for the confirm/submit button, enabled only once the checkbox
         * has been checked.
         */
        confirmLbl: {type: String, default: 'mead.labels.submit'},
        /**
         * Label text (i18n key) displayed next to the confirmation checkbox.
         */
        checkboxLbl: {type: String, default: ''},
    },
    components: {AthButton, AthFormCheckbox, Modal, ModalStandard},
    data () {
        return {
            confirmed: false,
        };
    },
    methods: {
        onSubmit: async function () {
            this.$emit('onSubmit');
        },
        onClose: function () {
            this.$emit('close');
        },
    },
};
</script>
